<template>
  <div>
    <TeCourseOrdermadeCover />
    <TeCourseOrdermadeReskillbanner />
    <TeCourseAbout>
      <template #title>
        オーダーメイドコースとは
      </template>
      <template #discription>
        <p class="co-display-10 mb-3 inline text-co-gray-500 md:block">
          20種類以上の専門コースを組み合わせ、
        </p>
        <p class="co-display-10 mb-3 inline text-co-gray-500 md:block">
          学習内容や期間をカスタマイズが可能なコースです。
        </p>
        <p class="co-display-10 mb-0 inline text-co-gray-500 md:block">
          一人ひとりの目的やご予算に応じた最適なプランをご提案します。
        </p>
      </template>
    </TeCourseAbout>
    <TeCourseOrdermadeTarget />
    <TeCourseOrdermadeMerit />
    <TeCourseOrdermadeCustomplan />

    <!-- VibeCodingが追加で学べる -->
    <TeCourseOrdermadeVibeCoding />

    <TeCourseOrdermadeCtafirst />
    <TeCourseOrdermadeSupport />
    <TeCourseOrdermadeInterview />

    <!-- リスキリングを通じたキャリアアップ支援事業認定講座 -->
    <TeCommonCareerUp :cashback-amount="false" />

    <TeCourseOrdermadeFlow />
    <TeCourseOrdermadeCtaSecond />
    <TeCourseOrdermadeMedia />
    <TeCourseOrdermadeFaq />
    <TeCourseOrdermadeCtaThird />
  </div>
</template>

<script lang="ts">
import { metaTags } from '~/utility/constants/metaTags'
import { IndexServices } from '~/services/indexService'
import { scriptTag } from '~/utility/scriptTag'
import { getCohorts, getCurrentPromotion, getCourse } from '~/utility/fetchAPI'
import { getAdItem } from '~/utility/utility'
import TeCourseOrdermadeCover from '~/components/Te/TeCourse/Ordermade/TeCourseOrdermadeCover.vue'
import TeCourseOrdermadeReskillbanner from '~/components/Te/TeCourse/Ordermade/TeCourseOrdermadeReskillbanner.vue'
import TeCourseAbout from '~/components/Te/TeCourse/TeCourseAbout.vue'
import TeCourseOrdermadeTarget from '~/components/Te/TeCourse/Ordermade/TeCourseOrdermadeTarget.vue'
import TeCourseOrdermadeMerit from '~/components/Te/TeCourse/Ordermade/TeCourseOrdermadeMerit.vue'
import TeCourseOrdermadeCustomplan from '~/components/Te/TeCourse/Ordermade/TeCourseOrdermadeCustomplan.vue'
import TeCourseOrdermadeVibeCoding from '~/components/Te/TeCourse/Ordermade/TeCourseOrdermadeVibeCoding.vue'
import TeCourseOrdermadeCtafirst from '~/components/Te/TeCourse/Ordermade/TeCourseOrdermadeCtafirst.vue'
import TeCourseOrdermadeSupport from '~/components/Te/TeCourse/Ordermade/TeCourseOrdermadeSupport.vue'
import TeCourseOrdermadeInterview from '~/components/Te/TeCourse/Ordermade/TeCourseOrdermadeInterview.vue'
import TeCommonCareerUp from '~/components/Te/TeCommon/CareerUp/TeCommonCareerUp.vue'
import TeCourseOrdermadeFlow from '~/components/Te/TeCourse/Ordermade/TeCourseOrdermadeFlow.vue'
import TeCourseOrdermadeCtaSecond from '~/components/Te/TeCourse/Ordermade/TeCourseOrdermadeCtaSecond.vue'
import TeCourseOrdermadeMedia from '~/components/Te/TeCourse/Ordermade/TeCourseOrdermadeMedia.vue'
import TeCourseOrdermadeFaq from '~/components/Te/TeCourse/Ordermade/TeCourseOrdermadeFaq.vue'
import TeCourseOrdermadeCtaThird from '~/components/Te/TeCourse/Ordermade/TeCourseOrdermadeCtaThird.vue'

const options = {
  async setup() {
    const route = useRoute()
    const courseNamePath = route.path.split('/')[2]
    const course = ref<Object | null>(null)

    return {
      route,
      course,
      courseNamePath,
    }
  },
  oldHead() {
    const scriptTags = scriptTag({
      facebookPixelCode: true, // Facebookピクセル
      criteoScript: true, // Criteo
      criteoItem: {
        deviceSize: useNuxtApp().$deviceSize,
        item: this.course?.id,
      },
      remarketingTag: {
        ad_item_id: this.course?.id,
        ad_item_price: this.course ? getAdItem(this.course) : null,
      },
    })
    return {
      title: 'オーダーメイドコース | テックアカデミー',
      meta: [
        ...metaTags(
          {
            description:
              '20種類以上のコースを自由に組み合わせてあなただけのオーダーメイドプランをご用意。要望に合わせて転職や副業のサポートもあり。',
            twitterTitle: 'オーダーメイドコース',
            twitterDescription:
              '20種類以上のコースを自由に組み合わせてあなただけのオーダーメイドプランをご用意。要望に合わせて転職や副業のサポートもあり。',
            twitterImage: '/_nuxt/ogp/te/tecourse/og-image-ordermade.jpg',
            ogTitle: 'オーダーメイドコース',
            ogDescription:
              '20種類以上のコースを自由に組み合わせてあなただけのオーダーメイドプランをご用意。要望に合わせて転職や副業のサポートもあり。',
            ogUrl: '/course/ordermade',
            ogImage: '/_nuxt/ogp/te/tecourse/og-image-ordermade.jpg',
            noIndexNofollow: true,
          },
          process.env.host as string
        ),
      ],
      script: scriptTags!.script,
      noscript: scriptTags!.noscript,
    }
  },
  data() {
    return {
      cohorts: [],
      latestCohort: null,
      sakiwariCohorts: [],
      currentPromotion: null,
      screenName: '',
      entryDiscountTimeLimit: null,
      entrySettlementTimeLimit: null,
      entryPaymentUrl: null,
    }
  },
  async mounted() {
    const {
      data: {
        entryDiscountTimeLimit,
        entrySettlementTimeLimit,
        entryPaymentUrl,
      },
    } = await new IndexServices(this.$api).getTopTimeLimits()
    this.entryDiscountTimeLimit = entryDiscountTimeLimit
    this.entrySettlementTimeLimit = entrySettlementTimeLimit
    this.entryPaymentUrl = entryPaymentUrl
    const queryConfig = {
      course_screen_name: this.courseNamePath,
      normal_opened: true,
      cohort_count: 6,
    }
    getCohorts(this.$api, queryConfig).then((response) => {
      this.cohorts = response.data
      this.latestCohort = response.data[0]
    })
    // getCohorts(this.$api, {
    //   course_screen_name: this.courseNamePath,
    //   sakiwari: true,
    // }).then((response) => {
    //   this.sakiwariCohorts = response.data
    // })
    getCurrentPromotion(this.$api).then((response) => {
      this.currentPromotion = response.data
    })
    this.course = (
      await getCourse(this.$api, this.courseNamePath, { include_pack: true })
    )?.data
  },
  computed: {
    BannerNameForShowing() {
      if (this.entrySettlementTimeLimit) {
        return 'settlement'
      } else if (this.entryDiscountTimeLimit) {
        return 'discount'
      } else {
        return null
      }
    },
    beginsAt() {
      return this.latestCohort
        ? new Date(this.latestCohort.attributes.begins_at)
        : null
    },
    closesAt() {
      return this.latestCohort
        ? new Date(this.latestCohort.attributes.closes_at)
        : null
    },
  },
  methods: {},
  components: {
    TeCourseOrdermadeCover,
    TeCourseOrdermadeReskillbanner,
    TeCourseAbout,
    TeCourseOrdermadeTarget,
    TeCourseOrdermadeMerit,
    TeCourseOrdermadeCustomplan,
    TeCourseOrdermadeVibeCoding,
    TeCourseOrdermadeCtafirst,
    TeCourseOrdermadeSupport,
    TeCourseOrdermadeInterview,
    TeCommonCareerUp,
    TeCourseOrdermadeFlow,
    TeCourseOrdermadeCtaSecond,
    TeCourseOrdermadeMedia,
    TeCourseOrdermadeFaq,
    TeCourseOrdermadeCtaThird,
  },
}

export default defineNuxtComponent(options)
</script>
